export const sampleFiles = (
  state = {
    products: [{ files: [] }],
    fileArray: { 0: [] },
    productIndexes: {},
  },
  action
) => {
  if (action.type === 'SET_SAMPLE_FILES') {
    const { productIndex, file, isRemove = false } = action.payload;

    if (!isRemove) {
      if (!state.products[productIndex]) {
        state.products[productIndex] = { files: [file] };
        state.fileArray[productIndex] = [file.name];
      } else {
        state.products[productIndex].files.push(file);
        state.fileArray[productIndex].push(file.name);
      }
      state.productIndexes[file.name] = productIndex;
    } else if (state.products[productIndex]) {
      const index = state.products[productIndex].files.indexOf(file);

      if (index > -1) {
        state.products[productIndex].files.splice(index, 1);
        state.fileArray[productIndex].splice(index, 1);
      }
      delete state.productIndexes[file.name];
    }

    const newState = { ...state };

    return newState;
  }

  if (action.type === 'DELETE_PRODUCT_SAMPLE') {
    const { productIndex } = action.payload;

    state.products.splice(productIndex, 1);

    delete state.fileArray[productIndex];

    for (const key of Object.keys(state.fileArray).sort()) {
      if (key === productIndex) {
        delete state.fileArray[key];
      }
      if (key > productIndex) {
        state.fileArray[key - 1] = state.fileArray[key];

        delete state.fileArray[key];
      }
    }

    for (const [key, value] of Object.entries(state.productIndexes)) {
      if (value === productIndex) {
        delete state.productIndexes[key];
      }

      if (value > productIndex) {
        state.productIndexes[key] = value - 1;
      }
    }

    const newState = { ...state };

    return newState;
  }

  if (action.type === 'CLEAR_SAMPLE_FILES') {
    return {
      products: [{ files: [] }],
      fileArray: { 0: [] },
      productIndexes: {},
    };
  }

  return state;
};

export const samples = (state = [], action) => {
  if (action.type === 'FETCH_SAMPLES') {
    return action.payload;
  }

  if (action.type === 'CLEAR_SAMPLES') {
    return [];
  }

  return state;
};

export const sample = (state = {}, action) => {
  if (action.type === 'FETCH_SAMPLE') {
    return action.payload;
  }

  if (action.type === 'CLEAR_SAMPLE') {
    return {};
  }

  return state;
};

export const samplePreview = (state = {}, action) => {
  if (action.type === 'FETCH_SAMPLE_PREVIEW') {
    return action.payload;
  }

  if (action.type === 'CLEAR_SAMPLE_PREVIEW') {
    return {};
  }

  return state;
};

export const sampleItemsToIssue = (
  state = { fabrics: [], accessories: [] },
  action
) => {
  if (action.type === 'FETCH_SAMPLE_ITEMS_TO_ISSUE') {
    return action.payload;
  }

  if (action.type === 'CLEAR_SAMPLE_ITEMS_TO_ISSUE') {
    return { fabrics: [], accessories: [] };
  }

  return state;
};
